




import { Component, Vue } from "vue-property-decorator";
import { getScrollParent } from "@/utils";

@Component({})
export default class IntersectionSentinel extends Vue {
  private observer?: IntersectionObserver;

  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry && entry.isIntersecting) {
          this.$emit("intersected");
        }
      },
      { root: getScrollParent(this.$el) }
    );

    this.observer.observe(this.$el);
  }

  destroyed() {
    if (this.observer) this.observer.disconnect();
  }
}
